// tr strings for messages/voice.ts. Same keys and {variables} as en there.
// SEO follows how Turkish users search: "{name} yapay zeka sesi", "AI cover".
import type { Dict } from "../index";

const voice: Dict = {
  "voice.seo.title": "{name} yapay zeka sesi: dinle ve AI cover yap | Jammable",
  "voice.seo.description":
    "{name} AI cover'larını dinle, kendi cover'ını yaklaşık bir dakikada yap. Topluluğun hazırladığı {name} yapay zeka sesini Jammable'da şarkılar, metinden sese ve düetler için kullan.",
  "voice.seo.appName": "{name} yapay zeka ses oluşturucu",
  "voice.seo.private": "Özel ses | Jammable",
  "voice.name": "{name} yapay zeka sesi",

  "voice.removed": "Bu ses kaldırıldı.",
  "voice.private": "Bu ses özel.",
  "voice.browseOther": "Diğer seslere göz at",

  "voice.error": "Bir şeyler ters gitti. Lütfen tekrar dene",
  "voice.copied": "Panoya kopyalandı!",

  "voice.newer.body": "{username} bu sesi güncelledi. Yeni sürümü dene",
  "voice.newer.cta": "Yeni sürüm",
  "voice.communityFavourite": "Topluluğun favorisi",
  "voice.uploadedBy": "Yükleyen: {name}",
  "voice.voices.one": "{n} ses",
  "voice.voices.other": "{n} ses",
  "voice.createCover": "Cover oluştur · {uses} kullanım",
  "voice.like": "Sesi beğen",
  "voice.unlike": "Beğenmekten vazgeç",
  "voice.comments": "Yorumlar",
  "voice.saveToCollection": "Koleksiyona kaydet",
  "voice.share": "Sesi paylaş",
  "voice.edit": "Sesi düzenle",
  "voice.report": "Sesi bildir",
  "voice.delete": "Sesi sil",
  "voice.more": "Daha fazla",
  "voice.description": "Açıklama",

  "voice.discord.label": "Toplulukla {name} hakkında konuş",
  "voice.discord.labelNoName": "Toplulukla yapay zeka sesleri hakkında konuş",
  "voice.discord.body":
    "Discord'da cover'larını paylaş, yeni ses iste ve ipuçları al",

  "voice.similar.title": "{name} gibi yapay zeka sesleri",
  "voice.similar.sub":
    "Kullanıcılar bu sesleri genellikle {name} ile kullandı.",
  "voice.similar.moreHub": "Daha fazla {badge} sesi",
  "voice.popularHub.title": "Popüler {badge} yapay zeka sesleri",
  "voice.seeAll": "Tümünü gör",
  "voice.collections.title": "{name} içeren koleksiyonlar",
  "voice.collections.titleNoName": "Bu sesi içeren koleksiyonlar",
  "voice.pairWell.title": "{name} ile iyi uyum sağlayan sesler",

  "voice.about.title": "{name} yapay zeka sesi hakkında",
  "voice.about.use":
    "{name} yapay zeka sesini AI cover yapmak, ses değiştirici olarak ya da metinden sese için kullan.",
  "voice.about.categorised": "Kategorileri: {list}.",
  "voice.about.uses": "Bu ses Jammable'da {n} kez kullanıldı.",
  "voice.howTo.title": "{name} AI cover nasıl yapılır",

  "voice.faq.title": "{name} yapay zeka sesi: sık sorulan sorular",
  "voice.faq.sub": "{name} sesiyle cover yapmak hakkında her şey.",
  "voice.link.aiCover": "AI cover oluşturucu",
  "voice.link.voiceChanger": "Yapay zeka ses değiştirici",
  "voice.link.browseAll": "Tüm yapay zeka seslerine göz at",
  "voice.link.weights": "Weights.gg alternatifi",
  "voice.faq.how.q": "{name} AI cover nasıl yapılır?",
  "voice.faq.how.a":
    "{name} AI cover yapmak için stüdyoda kendi ses dosyanı eklemen gerekir (lütfen {dmca} metnimizi oku). Ekledikten sonra dönüştürmeye hazırsın! {name} AI cover'ın yaklaşık 30-60 saniyede hazır olur.",
  "voice.faq.dmca": "DMCA Politikası",
  "voice.faq.input.q":
    "{name} AI cover'larım için hangi sesleri kullanabilirim?",
  "voice.faq.input.a":
    "Yalnızca kendi orijinal ses dosyalarını yükleyebilirsin. Hak sahibinin izni olmadan üçüncü tarafların telif hakkıyla korunan materyallerini içeren ses kayıtlarını kullanmamalısın.",
  "voice.faq.time.q": "{name} AI cover'ım ne kadar sürede hazır olur?",
  "voice.faq.time.a": "{name} AI cover'ın yaklaşık 30-60 saniyede hazır olur!",
  "voice.faq.credits.q": "Her {name} AI cover kaç kredi kullanır?",
  "voice.faq.credits.a": "Her {name} AI cover yalnızca 1 kredi kullanır!",
  "voice.faq.acapella.q": "Akapella yüklemem gerekiyor mu?",
  "voice.faq.acapella.a":
    "Hayır, akapella yüklemene gerek yok. Sistemimiz {name} AI cover'ın için akapellayı her durumda kendisi ayırır!",
  "voice.faq.changer.q":
    "{name} yapay zeka sesini ses değiştirici olarak kullanabilir miyim?",
  "voice.faq.changer.a":
    "Evet. {name} yapay zeka sesini ses değiştirici olarak ya da metinden sese için kullanabilirsin. Sesini yükle ya da kaydet, saniyeler içinde {name} sesine dönüştür.",
  "voice.faq.free.q": "{name} yapay zeka sesi ücretsiz mi?",
  "voice.faq.free.a":
    "{name} yapay zeka sesinin demolarını dinlemek ve bir cover hazırlamak ücretsiz. Cover yapmak için bir Jammable planı gerekir; plan sana sınırsız {name} AI cover, indirme ve daha fazlasını sunar.",

  "voice.demos.title": "Önce dinle",
  "voice.demos.note":
    "Demolar, seslerin kalitesini göstermek için otomatik olarak oluşturulur.",
  "voice.demos.maleSinging": "Erkek vokal {n}",
  "voice.demos.femaleSinging": "Kadın vokal {n}",
  "voice.demos.english": "İngilizce",
  "voice.play": "Çal: {name}",
  "voice.pause": "Duraklat: {name}",

  "voice.library.title": "Bu sesle şarkılar",
  "voice.library.sub":
    "{name} yapay zeka sesinin kütüphanemizdeki popüler şarkıları söyleyişini dinle.",
  "voice.library.unknownSong": "Bilinmeyen şarkı",
  "voice.library.unknownArtist": "Bilinmeyen sanatçı",

  "voice.comments.count.one": "{n} yorum",
  "voice.comments.count.other": "{n} yorum",
  "voice.comments.add": "Yorum ekle",
  "voice.comments.post": "Gönder",
  "voice.comments.top": "En iyi",
  "voice.comments.newest": "En yeni",
  "voice.comments.empty": "Burada hiç yorum yok...",
  "voice.comments.emptySub": "Sohbeti sen başlat!",
  "voice.comments.more": "Daha fazla yorum göster",
  "voice.comments.posted": "Yorum gönderildi!",
  "voice.comments.avatarAlt": "Kullanıcı avatarı",
  "voice.comments.creator": "Yaratıcı",
  "voice.comments.pinned": "Sabitlendi",
  "voice.comments.reply": "Yanıtla",
  "voice.comments.replyLabel": "Yorum yanıtı",
  "voice.comments.replyPlaceholder": "Sen ne düşünüyorsun?!",
  "voice.comments.viewReply.one": "{n} yanıtı gör",
  "voice.comments.viewReply.other": "{n} yanıtı gör",
  "voice.comments.viewMore": "{n} tane daha gör",
  "voice.comments.justNow": "az önce",
  "voice.comments.minutes": "{n} dk",
  "voice.comments.hours": "{n} sa",
  "voice.comments.days": "{n} g",
  "voice.comments.repliesFailed": "Yanıtlar yüklenemedi",
  "voice.comments.pinnedToast": "Yorum sabitlendi!",
  "voice.comments.unpinnedToast": "Yorumun sabitlemesi kaldırıldı!",
  "voice.comments.pinFailed": "Yorum sabitlenemedi",
  "voice.comments.pin": "Yorumu sabitle",
  "voice.comments.unpin": "Sabitlemeyi kaldır",
  "voice.comments.delete": "Yorumu sil",
  "voice.comments.report": "Yorumu bildir",

  "voice.addTo.title": "Koleksiyona ekle",
  "voice.addTo.error": "Koleksiyonlar yüklenirken hata oluştu: {message}",
  "voice.addTo.empty": "Hiç koleksiyon bulunamadı...",
  "voice.addTo.emptySub": "İlk koleksiyonunu oluştur!",
  "voice.addTo.new": "Yeni koleksiyon",
};

export default voice;
